var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoosting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1702.83 1067.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{opacity:0.7;fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4,.cls-5,.cls-7{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:4.43px;}.cls-4,.cls-5{stroke:#ffc800;}.cls-5{stroke-dasharray:12.17\n            12.17;}.cls-6{fill:#ffc800;}.cls-7{stroke:#006a6a;}.cls-8{fill:#006a6a;}.cls-9{fill:#6a0035;}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1024.91,
    y1: 854.71,
    x2: 1008.74,
    y2: 596.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#fff",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fff",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1501.28,
    y1: 1079.43,
    x2: 1501.28,
    y2: 3.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fff",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#fff",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fff",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#fff",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fff",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fff",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fff",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#fff",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1734.8,
    y1: 838.09,
    x2: 103.13,
    y2: 838.09,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph"
  }, /*#__PURE__*/React.createElement("path", {
    id: "graph_bg",
    className: "cls-1",
    d: "M508.4,831.07l41.26-58.81a3.65,3.65,0,0,1,5.39-.67l15,12.91a3.67,3.67,0,0,0,5.91-1.72L628,610.18a3.66,3.66,0,0,1,4.43-2.49l52.67,13.62a3.68,3.68,0,0,0,4.09-1.71l45.06-77.51a3.67,3.67,0,0,1,6.68.76l30.56,98.89a3.67,3.67,0,0,0,5.47,2l35.53-22.54a3.67,3.67,0,0,1,3.93,0l36.25,23a3.66,3.66,0,0,0,5.19-1.37l50.5-94.45a3.66,3.66,0,0,1,5.86-.83l37.43,38.28a3.67,3.67,0,0,0,5.92-1l56.76-118.25a3.67,3.67,0,0,1,5.25-1.53l62,38.68a3.67,3.67,0,0,0,3.88,0l67.88-42.25a3.68,3.68,0,0,1,4.69.68l41.83,47.29a3.67,3.67,0,0,0,5.48,0L1253,456.32a3.66,3.66,0,0,1,5-.47l45.2,34.56a3.66,3.66,0,0,0,5.61-1.51l21.61-52.21a3.66,3.66,0,0,1,3.21-2.26l57-2.81a3.67,3.67,0,0,0,3.28-2.45l35.31-101a3.66,3.66,0,0,1,1.18-1.66l68.21-54.38a3.66,3.66,0,0,1,6,2.86V835.18a3.67,3.67,0,0,1-3.68,3.67l-989.44-2A3.66,3.66,0,0,1,508.4,831.07Z",
    transform: "translate(-108.59 -7.78)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "axis"
  }, /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1501.28,7.78c1.83,88.94,2.79,177.87,3.44,266.81.41,44.46.5,88.93.74,133.4l.25,133.4-.24,133.4-.31,66.7-.16,33.36-.26,33.35c-.65,88.93-1.61,177.87-3.46,266.8-1.84-88.93-2.81-177.87-3.45-266.8l-.26-33.35-.17-33.36-.31-66.7-.23-133.4.24-133.4c.24-44.47.33-88.94.74-133.4C1498.49,185.65,1499.45,96.72,1501.28,7.78Z",
    transform: "translate(-108.59 -7.78)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.59,838.09c135.06-2.26,270.12-3.44,405.18-4.25l50.65-.31,50.65-.21,101.3-.39,202.59-.3,202.6.29,101.29.38,50.65.21,50.65.32c135.06.8,270.13,2,405.19,4.26-135.06,2.27-270.13,3.45-405.19,4.25l-50.65.32-50.65.21-101.29.38-202.6.29-202.59-.3-101.3-.38-50.65-.21-50.65-.32Q311.18,841.13,108.59,838.09Z",
    transform: "translate(-108.59 -7.78)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "yellow_arrow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_y"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1446.59,
    y1: 321.37,
    x2: 1442.65,
    y2: 326.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1543.37,343.08,1341.7,580.89a4.13,4.13,0,0,1-3.43,1.45l-182.2-12.87a4.09,4.09,0,0,0-3.52,1.55L1066.4,679.68a4.14,4.14,0,0,1-4.28,1.43l-123-32.21a4.11,4.11,0,0,0-3.73.87L753,807.28a4.15,4.15,0,0,1-3.17,1l-85.63-9.84a3.88,3.88,0,0,0-1.44.09L516.18,834",
    transform: "translate(-108.59 -7.78)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 401.68,
    y1: 827.62,
    x2: 395.77,
    y2: 829.05
  })), /*#__PURE__*/React.createElement("path", {
    id: "head_y",
    className: "cls-6",
    d: "M1529.47,340.14l28.21-15.3a1.47,1.47,0,0,1,2.09,1.75l-9.9,29.6a1.46,1.46,0,0,1-2.29.69l-18.31-14.3A1.46,1.46,0,0,1,1529.47,340.14Z",
    transform: "translate(-108.59 -7.78)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "green_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line_g",
    className: "cls-7",
    d: "M510.44,834.8l257.69-98a4.06,4.06,0,0,1,1.46-.27H887.47a4.16,4.16,0,0,0,3.19-1.51l136.59-167.28a4.11,4.11,0,0,1,4.9-1.14l172.44,78.83a4.12,4.12,0,0,0,3.87-.24l267.67-165",
    transform: "translate(-108.59 -7.78)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dots"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_4",
    className: "cls-8",
    cx: 659.24,
    cy: 729.74,
    r: 5.57
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_3",
    className: "cls-8",
    cx: 780.83,
    cy: 727.71,
    r: 5.57
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_2",
    className: "cls-8",
    cx: 920.67,
    cy: 557.48,
    r: 5.57
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ellipse_1",
    className: "cls-8",
    cx: 1098,
    cy: 638.54,
    r: 5.57
  })), /*#__PURE__*/React.createElement("path", {
    id: "head_g",
    className: "cls-8",
    d: "M1449.26,484l27.77-6.21a1.3,1.3,0,0,1,1.36,2l-15.62,22.85a1.3,1.3,0,0,1-2.13,0L1448.49,486A1.31,1.31,0,0,1,1449.26,484Z",
    transform: "translate(-108.59 -7.78)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "main_arrow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_main"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1807.94,272.68a752.66,752.66,0,0,1-125.26,186.59c-50.58,55.59-108.86,103.78-171.53,144.81s-129.75,75.15-199,103.41-140.74,50.81-213.26,68.73S952.78,807.5,878.76,817.17s-148.5,15.56-223.06,18.41q-55.92,2.13-111.89,2-14,0-28-.19c-4.67,0-9.33-.14-14-.15l-14,0L431.94,837l-223.72-.7L432,835.63l55.93-.18c9.32,0,18.65-.07,28,0s18.64,0,27.95,0q55.92-.33,111.77-2.85c74.45-3.42,148.77-9.91,222.57-20.09s147.08-24.07,219.2-42.5,143.08-41.42,211.72-70,134.87-63,196.65-104.1,119-89.18,168.38-144.34A740.35,740.35,0,0,0,1795.9,267.07a6.64,6.64,0,1,1,12.06,5.56Z",
    transform: "translate(-108.59 -7.78)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "head_main",
    className: "cls-9",
    d: "M1767.44,290.72l39.87-36.1a2.45,2.45,0,0,1,4.09,2L1807,308.77a2.46,2.46,0,0,1-3.46,2l-35.48-16A2.45,2.45,0,0,1,1767.44,290.72Z",
    transform: "translate(-108.59 -7.78)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoosting);
export default __webpack_public_path__ + "static/media/boosting.6744113930c7839a15a11d34fe398a16.svg";
export { ForwardRef as ReactComponent };